import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Container } from './Container';
import { ProductMockup } from './ProductMockup';
import { modules, systemIncludes, weekTabs } from '../data/landing';
export function ProductReveal() {
  return <section aria-labelledby="product-title" className="bg-cream py-16 sm:py-20 lg:py-24" data-id="element-318" data-mp="3619yom6kocg2">
      <Container data-id="element-319" data-mp="313qbuxvt6rci">
        <div className="mx-auto max-w-3xl text-center" data-id="element-320" data-mp="3114530gqsfvc">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.14em] text-teal-dark sm:text-sm" data-id="element-321" data-mp="2defg5utbfn58">
            30 Días de Viandas Resueltas
          </p>
          <h2 id="product-title" className="mt-3 text-balance font-heading text-[2rem] font-black leading-[1.08] tracking-[-0.01em] text-navy sm:text-4xl lg:text-[2.9rem]" data-id="element-322" data-mp="2n3pbdjjghlxk">
            Un mes completo. Todo organizado.
          </h2>
        </div>

        <div className="mt-12 grid items-start gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-14" data-id="element-323" data-mp="1pnta292vgcxv">
          <div className="lg:sticky lg:top-8" data-id="element-324" data-mp="1b0xm2ro4jr64">
            <ProductMockup decorated={false} className="mx-auto max-w-[480px]" data-id="element-325" data-mp="1azw7id7wgmjn" />
            <ul className="mt-5 flex flex-wrap justify-center gap-2" aria-label="Estructura del plan" data-id="element-326" data-mp="1f1radm5hb7zj">
              {weekTabs.map((w, i) => <li key={w} className={i === weekTabs.length - 1 ? 'rounded-full bg-pink-light px-3.5 py-1.5 text-sm font-bold text-navy' : 'rounded-full bg-teal-light/60 px-3.5 py-1.5 text-sm font-bold text-navy'} data-id="element-327" data-mp="1ju14zfhjgw85" data-mpi={i}>
                  {w}
                </li>)}
            </ul>
          </div>

          <div data-id="element-328" data-mp="162dyynxso9c6">
            <ol className="divide-y divide-teal-soft rounded-3xl border border-teal-soft bg-white px-5 shadow-soft sm:px-7" data-id="element-329" data-mp="162w3e7um1tv6">
              {modules.map(({
              icon: Icon,
              title,
              text
            }, i) => <li key={title} className="flex items-start gap-4 py-5" data-id="element-330" data-mp="2hg8aqspkwum3" data-mpi={i}>
                  <span className="w-8 shrink-0 pt-0.5 font-heading text-lg font-black text-pink" data-id="element-331" data-mp="1rsm30j3dmm8m">{String(i + 1).padStart(2, '0')}</span>
                  <div className="min-w-0 flex-1" data-id="element-332" data-mp="1msrf8oewecrs">
                    <h3 className="flex items-center gap-2 font-heading text-lg font-extrabold text-navy" data-id="element-333" data-mp="21r1uwoa89zj6">
                      <Icon aria-hidden="true" className="h-[18px] w-[18px] shrink-0 text-teal" data-id="element-334" data-mp="1ws8g8sj7g2hf" />
                      {title}
                    </h3>
                    <p className="mt-1 text-base leading-relaxed text-navy-soft" data-id="element-335" data-mp="192w8lx3j02h8">{text}</p>
                  </div>
                </li>)}
            </ol>

            <div className="mt-6 rounded-3xl bg-teal-light/45 p-5 sm:p-7" data-id="element-336" data-mp="1isftt9epo8f9">
              <p className="font-heading text-lg font-extrabold text-navy" data-id="element-337" data-mp="1e1h81uayei4m">En el sistema tenés:</p>
              <ul className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-338" data-mp="qbwnx832detr">
                {systemIncludes.map(item => <li key={item} className="flex items-center gap-3 text-base font-medium text-navy" data-id="element-339" data-mp="ldbovbzjt16w">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-teal text-white" data-id="element-340" data-mp="2wznar9mofs6u">
                      <CheckIcon aria-hidden="true" strokeWidth={3} className="h-3.5 w-3.5" data-id="element-341" data-mp="31rx6556k9kgi" />
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </Container>
    </section>;
}